module.exports = __webpack_public_path__ + "static/media/edit.2cb67602.png";